import { getFromFee } from './nltUtils'

export const FB_EVENTS = {
  AddPaymentInfo: 'AddPaymentInfo',
  AddToCart: 'AddToCart',
  AddToWishlist: 'AddToWishlist',
  CompleteRegistration: 'CompleteRegistration',
  FindLocation: 'FindLocation',
  InitiateCheckout: 'InitiateCheckout',
  Lead: 'Lead',
  PageView: 'PageView',
  Purchase: 'Purchase',
  Search: 'Search',
  ViewContent: 'ViewContent',
}

export default (name, product) => {
  if (typeof window !== 'undefined') {
    try {
      const type = Object.values(FB_EVENTS).includes(name)
        ? 'track'
        : 'trackCustom'

      const eventParameters = {}

      if (product) {
        // deduco info standard dall'auto
        eventParameters.value =
          product.prezzo_sellout || getFromFee('canone_mensile', product)
        eventParameters.tipo_veicolo = product.tipo_veicolo
        eventParameters.linea_prodotto = product.linea_prodotto
        eventParameters.currency = 'EUR'
        eventParameters.content_type = 'product'
        eventParameters.content_ids = [product.id_auto]
      }
      if ('fbq' in window) {
        window.fbq(type, name, eventParameters)
      }
    } catch (e) {}
  }
}
